import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Sunset = createReactComponent("Sunset", ["svg", defaultAttributes, [["path", {
  d: "M17 18a5 5 0 00-10 0",
  key: "1tb2kb"
}], ["line", {
  x1: "12",
  y1: "9",
  x2: "12",
  y2: "2",
  key: "1ya76y"
}], ["line", {
  x1: "4.22",
  y1: "10.22",
  x2: "5.64",
  y2: "11.64",
  key: "q2r4og"
}], ["line", {
  x1: "1",
  y1: "18",
  x2: "3",
  y2: "18",
  key: "1r97dh"
}], ["line", {
  x1: "21",
  y1: "18",
  x2: "23",
  y2: "18",
  key: "18g1a6"
}], ["line", {
  x1: "18.36",
  y1: "11.64",
  x2: "19.78",
  y2: "10.22",
  key: "4h1pi0"
}], ["line", {
  x1: "23",
  y1: "22",
  x2: "1",
  y2: "22",
  key: "5ycleo"
}], ["polyline", {
  points: "16 5 12 9 8 5",
  key: "jpnq8m"
}]]]);
export default Sunset;